module.exports = __webpack_public_path__ + "img/exchange-2.5b6a12c0.png";